import DetailPageContent from './components/detailPageContent';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageFooter from './components/pageFooter';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";


export const AboutPage = () => {
    return (
        <>
            <PageLayout>
                <PageContainer>
                    <PageBody>
                    <NavigationHeader></NavigationHeader>
                    <PageText>
                        <Container fluid className={'NailCommissionPageContent'}>
                            <Row className={'row'}>
                                <Col sm className={'colTitle'}>
                                    <a className={'navTitle'}> instagram links</a>
                                </Col>
                            </Row>

                            <Row xs={2} sm={2} className={'NailCommissionPage-row'}>
                                <Col sm className={'NailCommissionPage-col'}>
                                    <div className={'NailCommissionPage-ImageWrapper'}>
                                        <img className={'NailCommissionPage-Image'} src={require("../images/tamagotchi-mametchi.gif")} alt={""}></img>
                                    </div>
                                    <div className={'NailCommissionPage-TextWrapper'}>
                                        <a className={'NailCommissionPage-Text'} href="https://www.instagram.com/joysghost?igsh=MWE0cTAyMjl5a3ZvaQ==">NAILS </a>
                                    </div>
                                </Col>
                                <Col sm className={'NailCommissionPage-col'}>
                                    <div className={'NailCommissionPage-ImageWrapper'}>
                                        <img className={'NailCommissionPage-Image'} src={require("../images/kuchipatchi-spinning.gif")} alt={""}></img>
                                    </div>
                                    <div className={'NailCommissionPage-TextWrapper'}>
                                        <a className={'NailCommissionPage-Text'} href="https://www.instagram.com/egg.tarty/?igsh=cXc0em1pdmdqdHlk">ART </a>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        </PageText>
                    <PageFooter />
                </PageBody>
                </PageContainer>
            </PageLayout>
        </>
    )
}